import styled, { css } from "styled-components";

import breakpoint from "../utils/breakpoint";
import { fixPropWarnings } from "../utils/fixPropWarnings";

import CallToAction from './CallToAction';

export const HeaderButtonStyles = css`
  margin: 0px 10px;

  &:lang(fr) {
    line-height: 15px;
    min-height: 42px;
    max-height: 42px;
  }

  &:last-child {
    margin: 0px;
  }

  ${breakpoint('sm')(`
    padding: 10px 20px;
  `)}

  ${breakpoint('md')(`
    padding: 10px 20px;
    margin: 0px 10px;

    &:first-child {
      margin: 0 10px 0 20px;
    }

    &:last-child {
      margin: 0px 0px 0px 10px;
    }
  `)}

  ${breakpoint('xl')(`
     margin: 0px 15px;

    &:first-child {
      margin: 0 15px 0 30px;
    }

    &:last-child {
      margin: 0px 0px 0px 15px;
    }
  `)}

  @media only screen and (min-width: 1440px) {
    &:lang(fr) {
      min-width: 135px;
      margin: 0px 8px;

      &:first-child {
        margin: 0px 8px 0px 16px;
      }

      &:last-child {
        margin: 0px 0px 0px 8px;
      }
    }
  }
`;

export const HeaderCallToAction = styled(CallToAction)`
  ${HeaderButtonStyles}
`;

export const GetAQuoteWrapper = styled.div.withConfig(fixPropWarnings('color', 'inline'))<{color: string, inline: boolean}>`
  color: ${({ theme, color }) => theme.colors[color]};
  display: ${({ inline }) => (inline ? 'flex' : 'block')};
  gap: 8px;
`;

export const GetAQuoteLabel = styled.div.withConfig(fixPropWarnings('inline'))<{inline: boolean}>`
  font-size: ${({ inline }) => inline ? '18px' : '14px'};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: 18px; /* 128.571% */
`;

export const GetAQuoteLink = styled.a.withConfig(fixPropWarnings('color', 'inline'))<{color: string, inline: boolean}>`
  text-align: right;
  font-size: ${({ inline }) => inline ? '24px' : '18px'};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  line-height: 18px; /* 100% */
  color: ${({ theme, color }) => theme.colors[color]};
`;
